import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";
import { Roundtable } from "../../types/Roundtable";
import { mapRoundtableFormValues, RoundtableFormValues } from "./mapRoundtableForm";

type EditRoundtableParams = {
  values: RoundtableFormValues & { id: string };
};

// Updates the editable fields only. The agenda, participants, and status are
// owned by the app at runtime, so editing here never regenerates the agenda
// (the host uses "Refresh agenda" in the app for that). Recurrence is replaced
// when toggled off so a single roundtable stops projecting occurrences.
export default async ({ values }: EditRoundtableParams): Promise<void> => {
  const { id } = values;
  if (!id) {
    console.error("editRoundtable called without an id");
    return;
  }

  const mapped = mapRoundtableFormValues(values);

  const update: Partial<Roundtable> = {
    title: mapped.title,
    goal: mapped.goal,
    startTime: mapped.startTime,
    endTime: mapped.endTime,
    maxParticipants: mapped.maxParticipants ?? null,
    // Replace (not merge) recurrence; clear to null when no longer recurring.
    // The app treats a falsy recurrence as a single roundtable, so null is safe.
    recurrence: mapped.recurrence ?? null,
    updatedAt: new Date().toISOString(),
  } as Partial<Roundtable>;

  await firestore
    .collection(DB_PATH.COMMUNITY_ROUNDTABLE)
    .doc(id)
    .update(update)
    .then(() => console.log("Roundtable updated", id))
    .catch((error) => console.error("Error updating roundtable:", error));
};
